// extracted by mini-css-extract-plugin
export default {"selectWrapper":"double_section_select_pill-module___selectWrapper___b953db3d","customSelect":"double_section_select_pill-module___customSelect___ef6d0275"};